import { render, staticRenderFns } from "./EditFavorite.vue?vue&type=template&id=1c50d186&scoped=true"
import script from "./EditFavorite.vue?vue&type=script&lang=js"
export * from "./EditFavorite.vue?vue&type=script&lang=js"
import style0 from "./EditFavorite.vue?vue&type=style&index=0&id=1c50d186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50d186",
  null
  
)

export default component.exports